import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { WebhookSubscriptionsContent } from "./WebhookSubscriptionsContent";

import Tabs from "@/components/ui/v2/tabs";

type WebhookTabWrapperProps = {
  integrationId?: string;
  scopes?: string[];
  children: React.ReactNode;
};

export function WebhookTabWrapper({
  integrationId,
  scopes,
  children,
}: WebhookTabWrapperProps) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const hasWebhookScopes = scopes?.some((s) => s.startsWith("webhooks:"));

  if (!hasWebhookScopes) {
    return <>{children}</>;
  }

  const tabFromUrl = searchParams.get("tab");
  const activeTabId = tabFromUrl === "webhooks" ? "webhooks" : "overview";

  const handleTabChange = (tab: { id?: string }) => {
    const newParams = new URLSearchParams(searchParams);
    if (tab.id === "webhooks") {
      newParams.set("tab", "webhooks");
    } else {
      newParams.delete("tab");
    }
    setSearchParams(newParams, { replace: true });
  };

  const tabs = [
    {
      id: "overview",
      label: t("common.overview"),
      content: <div className="mt-6">{children}</div>,
    },
    {
      id: "webhooks",
      label: t("webhooks.subscriptions.title"),
      content: (
        <div className="mt-6">
          <WebhookSubscriptionsContent integrationId={integrationId} />
        </div>
      ),
    },
  ];

  return (
    <Tabs tabs={tabs} defaultTabId={activeTabId} onChange={handleTabChange} />
  );
}
